// project-params.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({ providedIn: 'root' })
export class ProjectParametersService {

  private apiUrl = `${environment.baseUrl}/projectParameters`;


  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }


  getTemplates(): Observable<any[]> {
    console.log(`${this.apiUrl}/getTemplates`);
    

  let aaa =  this.commonAPI.getApiCall(`${this.apiUrl}/getTemplates`);
  console.log
  (aaa);
  return aaa;
    // return this.http.get<any[]>(`${this.apiUrl}/getTemplates`);
  }

  getLayouts(): Observable<any> {
    console.log(`${this.apiUrl}/getLayouts`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getLayouts`);
    // return this.http.get<any[]>(`${this.apiUrl}/getLayouts`);
  }

  getProjectParams(projectId: string): Observable<any> {
    console.log(`${this.apiUrl}/getProjectParams/${projectId}`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getProjectParams/${projectId}`);
    // return this.http.get<any>(`${this.apiUrl}/getProjectParams/${projectId}`);
  }

  saveProjectParams(data: any): Observable<any> {
    console.log(data);
    console.log("calling save web service");

const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });


        let body = {
      "criteria": {
        "projectId":data.projectId,
         "templateId":data.templateId, 
         "layoutIds":data.layoutIds, 
         "customFields":data.customFields,
         "projectAudioStrategy": data.projectAudioStrategy,
         "projectBreakOnNewline": data.projectBreakOnNewline || 'N',
         "projectDefaultLayoutSC": data.projectDefaultLayoutSC || null,
         "projectAudioOptions": (data.audioOptions || []).map((o: any) => ({
           key: o.key,
           language: o.language || '',
           voice: o.voice,
           "voice-speed": o.voiceSpeed,
           "voice-volume": o.voiceVolume
         })),
               tenant: null
      }
    };

    let aaa= this.commonAPI.postApiCall(`${this.apiUrl}/saveProjectParams`, body);
    console.log(aaa);
    return aaa;


    // return this.http.post<any>(`${this.apiUrl}/saveProjectParams`, data);

  }

}
